import { Backdrop } from "@mui/material";
import React from "react";

import { CircularProgress } from "@components/base";
import { useGetFormAssignmentConfig, useIsMutatingUpdateFormAssignment } from "@api";
import { useUserStore } from "@store/user";

interface LoaderProps {
  formId: string;
}

const Loader: React.FC<LoaderProps> = ({ formId }) => {
  const { user } = useUserStore();
  const isMutatingUpdateFormAssignment = useIsMutatingUpdateFormAssignment();
  const { isFetchingGetFormAssignmentConfig } = useGetFormAssignmentConfig(user, {
    formId,
  });
  const isVisible =
    isMutatingUpdateFormAssignment || isFetchingGetFormAssignmentConfig;

  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={isVisible}
      onClick={(e) => e.preventDefault()}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
